<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
    <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()">No</button>
    <button mat-button (click)="onYesClick()" cdkFocusInitial>Yes</button>
</div>